import { render } from "./ScheduleTable.vue?vue&type=template&id=4bdbff14"
import script from "./ScheduleTable.vue?vue&type=script&lang=ts"
export * from "./ScheduleTable.vue?vue&type=script&lang=ts"
script.render = render

export default script